import { Sparkles } from "lucide-react";

/**
 * Small white badge with a sparkles icon (Figma "IA/Badge", node 650:149425): marks a new or
 * AI-made feature next to a title. Text in gray-900, 12px medium.
 */
const FeatureBadge = ({ children }) => (
    <span className="inline-flex shrink-0 items-center gap-1 rounded-md border border-gray-100 bg-white px-1.5 py-1 text-xs font-medium leading-4 text-gray-900">
        <Sparkles size={12} strokeWidth={2} color="#111827" aria-hidden="true" />
        {children}
    </span>
);

export default FeatureBadge;
